import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, SpinnerLoader, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  HubspotWorkflowsListContext,
  useHubspotWorkflowsListContext,
} from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/context/context'
import { HubspotWorkflowsListStore } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/store/HubspotWorkflowsListStore'
import { HubspotWorkflowsTable } from 'pages/hubspotWorkflows/ui/hubspotWorkflowsList/ui/HubspotWorkflowsTable'

const HubspotWorkflowsListContent = observer(() => {
  const { isInitialLoading, isEmpty } = useHubspotWorkflowsListContext()

  if (isInitialLoading) {
    return <SpinnerLoader ariaLabel={'HubspotWorkflowsList'} />
  }

  if (isEmpty) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' height='100%' width='100%'>
        <Typography
          variant={'body-rg-medium'}
          ellipsis
          ariaLabel={'empty_placeholder'}
          color={'tertiary'}
        >
          No workflows found
        </Typography>
      </Box>
    )
  }

  return <HubspotWorkflowsTable />
})

export const HubspotWorkflowsList = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new HubspotWorkflowsListStore(entities), [])

  useEffect(store.init, [store])

  return (
    <HubspotWorkflowsListContext.Provider value={store}>
      <HubspotWorkflowsListContent />
    </HubspotWorkflowsListContext.Provider>
  )
}
